import React from 'react';
import PropTypes from 'prop-types';
import { BiLinkAlt } from 'react-icons/bi';

import GenericDetails from 'partial/components/GenericDetails';

const COMPANY_PROFILE_FORMAT = [
  {
    label: 'Business Name',
    key: 'name',
  },
  {
    label: 'Website or social media page of your business',
    key: (row) => (
      <>
        {row?.website_url ? (
          <a
            href={row?.website_url}
            className="text-gray-500 hover:text-primary-400 font-medium flex items-center space-x-1"
          >
            <span>{row?.website_url}</span>
            <BiLinkAlt className="w-4 h-4 flex-shrink-b" />
          </a>
        ) : (
          <span>--</span>
        )}
      </>
    ),
  },
  {
    label: 'Customer Service Number',
    key: 'customer_service_number',
  },
  {
    label: 'Email Address',
    key: 'email',
  },
  {
    label: 'Industry',
    key: 'industry',
  },
  {
    label: 'Product description and nature of business',
    key: 'business_description',
  },
];

const BUSINESS_ADDRESS_FORMAT = [
  {
    label: 'Complete Address',
    key: (row) => (
      <span>
        {row?.unit_no ? `${row?.unit_no}, ` : ''}
        {row?.house_no ? `${row?.house_no}, ` : ''}
        {row?.building_name ? `${row?.building_name}, ` : ''}
        {row?.street ? `${row?.street}, ` : ''}
        {row?.district ? `${row?.district}, ` : ''}
        {row?.postal_code ? `${row?.postal_code}, ` : ''} Brunei
      </span>
    ),
  },
];

function MerchantGeneralInfo({ data, isLoading, role }) {
  return (
    <>
      <div className="title-h1 mb-3 pb-4 border-b-4 border-gray-100">
        General Information
      </div>
      <div className="data-container py-4 border-b-4 border-gray-100">
        <div className="title-h2 mb-5">Company Profile</div>
        <GenericDetails
          data={data || {}}
          isLoading={isLoading}
          format={COMPANY_PROFILE_FORMAT}
          numberOfCols={role === 'biller' ? 3 : 2}
        />
      </div>
      <div className="data-container py-4">
        <div className="title-h2 mb-5">Business Address</div>
        <GenericDetails
          data={data || {}}
          isLoading={isLoading}
          format={BUSINESS_ADDRESS_FORMAT}
          numberOfCols={1}
        />
      </div>
    </>
  );
}

MerchantGeneralInfo.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool,
  role: PropTypes.string,
};

MerchantGeneralInfo.defaultProps = {
  isLoading: false,
  role: '',
};

export default MerchantGeneralInfo;
